module.exports = __webpack_public_path__ + "static/media/menu-new.b52825ef.svg";